import { useEffect, useState, memo } from "react";
import { getUserById } from "../../api/api.js";
import { format } from "date-fns";
import fi from "date-fns/locale/fi";

const cache = {};

function SectionLastEdited({ updatedBy, updatedAt }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!updatedBy) return;
    if (cache[updatedBy]) { setUser(cache[updatedBy]); return; }
    let mounted = true;
    getUserById(updatedBy)
      .then(res => { cache[updatedBy] = res.data; if (mounted) setUser(res.data); })
      .catch(() => { if (mounted) setUser(null); });
    return () => { mounted = false; };
  }, [updatedBy]);

  const formattedDate = updatedAt
    ? format(new Date(updatedAt), "d.M.yyyy HH:mm", { locale: fi })
    : null;

  const who = user ? `${user.nimi}${user.ammattinimike ? ` (${user.ammattinimike})` : ''}` : '–';

  return (
    <span style={{ color: '#adb5bd', fontSize: '0.72rem' }}>
      Muokattu: <span style={{ color: '#6c757d' }}>{who}</span>
      {formattedDate && <> · <span style={{ color: '#6c757d' }}>{formattedDate}</span></>}
    </span>
  );
}

export default memo(SectionLastEdited);
